import id1 from '../images/thumbnail/id1.png';
import id2 from '../images/thumbnail/id2.png';
import id3 from '../images/thumbnail/id3.png';
import id4 from '../images/thumbnail/id4.png';
import id5 from '../images/thumbnail/id5.png';
import id6 from '../images/thumbnail/id6.png';
import id7 from '../images/thumbnail/id7.png';
import id8 from '../images/thumbnail/id8.png';
import id9 from '../images/thumbnail/id9.png';
import id10 from '../images/thumbnail/id10.png';
import id11 from '../images/thumbnail/id11.png';
import id12 from '../images/thumbnail/id12.png';
import id13 from '../images/thumbnail/id13.png';
import id14 from '../images/thumbnail/id14.png';
import id15 from '../images/thumbnail/id15.png';
import id16 from '../images/thumbnail/id16.png';
import id17 from '../images/thumbnail/id17.png';


// Categories for the filter bar
export const filterCategories = [
    { label: 'All Services', target: 'all' },
    { label: 'Archana', target: 'archana' },
    { label: 'Special Archana', target: 'special_archana' },
];

// All services data in a single array
export const services = [
    {
        id: 1,
        type: 'archana',
        temple: 'Navagraha Temples',
        title: 'All Navagraha Temples Archana',
        //description: 'Perform Archana across all nine Navagraha Temples for planetary blessings.',
        imageUrl: id1,
        price: 8999,
    },
    {
        id: 2,
        type: 'archana',
        temple: 'Suryanar Kovil',
        title: 'Surya Bhagavan Temple (Sun) - Suryanar Kovil',
        //description: 'Archana for Surya Bhagavan to seek blessings for health and vitality.',
        imageUrl: id2,
        price: 2799,
    },
    {
        id: 3,
        type: 'archana',
        temple: 'Thingaloor',
        title: 'Chandran Bhagavan Temple (Moon) - Thingaloor',
        //description: 'Archana for Chandran Bhagavan to invoke peace of mind and emotional well-being.',
        imageUrl: id3,
        price: 2799,
    },
    {
        id: 4,
        type: 'archana',
        temple: 'Alangudi',
        title: 'Guru Bhagavan Temple (Jupiter) - Alangudi',
        //description: 'Archana for Guru Bhagavan to receive blessings for wisdom, education, and prosperity.',
        imageUrl: id4,
        price: 2299,
    },
    {
        id: 5,
        type: 'archana',
        temple: 'Tiruvengadu',
        title: 'Budhan Bhagavan Temple (Mercury) - Tiruvengadu',
        //description: 'Archana for Budhan Bhagavan for enhanced intelligence, communication, and business success.',
        imageUrl: id5,
        price: 2899,
    },
    {
        id: 6,
        type: 'archana',
        temple: 'Vaitheeswaran Kovil',
        title: 'Chevvai Bhagavan Temple (Mars) - Vaitheeswaran Kovil',
        //description: 'Archana for Chevvai Bhagavan to gain courage, strength, and overcome obstacles.',
        imageUrl: id6,
        price: 2799,
    },
    {
        id: 7,
        type: 'archana',
        temple: 'Keezhperumpallam',
        title: 'Kethu Bhagavan Temple - Keezhperumpallam',
        //description: 'Archana for Kethu Bhagavan to mitigate negative influences and achieve spiritual liberation.',
        imageUrl: id7,
        price: 2799,
    },
    {
        id: 8,
        type: 'archana',
        temple: 'Thirunageswaram',
        title: 'Rahu Bhagavan Temple - Thirunageswaram',
        //description: 'Archana for Rahu Bhagavan for protection from evil forces and sudden misfortunes.',
        imageUrl: id8,
        price: 1499,
    },
    {
        id: 9,
        type: 'archana',
        temple: 'Thirunallar',
        title: 'Sani Bhagavan Temple (Saturn) - Thirunallar',
        //description: 'Archana for Sani Bhagavan to alleviate the effects of Sani Dosha and bring good fortune.',
        imageUrl: id9,
        price: 2999,
    },
    {
        id: 10,
        type: 'archana',
        temple: 'Kanjanur',
        title: 'Sukran Bahavan Temple (Venus) - Kanjanur',
        //description: 'Archana for Sukran Bhagavan for marital bliss, artistic talents, and material comforts.',
        imageUrl: id10,
        price: 2799,
    },
    {
        id: 11,
        type: 'special_archana',
        temple: 'Mahalingeswarar Temple',
        title: 'Mahalingeswarar Temple',
        //description: 'Perform Archana at the sacred Mahalingeswarar Temple for immense blessings from Lord Shiva.',
        imageUrl: id11,
        price: 1799,
    },
    {
        id: 12,
        type: 'special_archana',
        temple: 'Amirthakadeswarar Temple',
        title: 'Amirthakadeswarar Temple',
        //description: 'Archana at Amirthakadeswarar Temple for longevity and good health.',
        imageUrl: id12,
        price: 2699,
    },
    {
        id: 13,
        type: 'special_archana',
        temple: 'Sri Sarabeshwarar Temple',
        title: 'Sri Sarabeshwarar Temple',
        //description: 'Offer prayers to Sri Sarabeshwarar for protection from evil and negative energies.',
        imageUrl: id13,
        price: 1599,
    },
    {
        id: 14,
        type: 'special_archana',
        temple: 'Jagannatha Perumal Temple',
        title: 'Jagannatha Perumal Temple',
        //description: 'Archana at Jagannatha Perumal Temple for the blessings of Lord Vishnu.',
        imageUrl: id14,
        price: 2699,
    },
    {
        id: 15,
        type: 'special_archana',
        temple: 'Nageswaraswamy Temple',
        title: 'Nageswaraswamy Temple',
        //description: 'Special Archana at Nageswaraswamy Temple for mitigating Rahu-Kethu Doshas.',
        imageUrl: id15,
        price: 1299,
    },
    {
        id: 16,
        type: 'special_archana',
        temple: 'Prathyangira Devi Temple',
        title: 'Prathyangira Devi Temple',
        //description: 'Powerful Archana at Prathyangira Devi Temple for protection against black magic and evil eyes.',
        imageUrl: id16,
        price: 1799,
    },
    {
        id: 17,
        type: 'special_archana',
        temple: 'Ramaswamy Temple',
        title: 'Ramaswamy Temple',
        //description: 'Archana at Ramaswamy Temple for the blessings of Lord Rama, promoting harmony.',
        imageUrl: id17,
        price: 1599,
    },
];
